import {Component, Input, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {ConstsHelper} from '../../../../helpers/consts.helper';
import {GetMsisdnProcedures} from '../../store/actions/msisdn-procedures.actions';
import {MsisdnProcedureInterface} from '../../models/msisdn-procedure.interface';
import {MsisdnProcedureInterfaceState} from '../../store/state/msisdn-procedure.state';
import {UpdateSelectedProcedure} from '../../../shared/store/actions/selected-procedure.actions';
import {SelectedProcedureInterfaceState} from '../../../shared/store/state/selected-procedure.state';
import {LineInterface} from '../../models/line.interface';
import {environment} from '../../../../../environments/environment';
import {ConsumptionInterfaceState} from '../../store/state/consumption.state';
import {ConsumptionInterface} from '../../models/consumption.interface';
import {GetAddress} from '../../../account/store/actions/address.actions';
import {LineInterfaceState} from '../../store/state/line.state';
import {CustomerInterface} from '../../../account/models/customer.interface';
import {CustomerStorageService} from '../../../account/services/customer-storage.service';
import {PriceDetailsInterface} from '../../../shared/models/price-details.interface';
import {DisplayProcedureMessageService} from '../../services/display-procedure-message.service';
import moment from 'moment';
import {PortabilityDatesService} from '../../../shared/services/portability-dates.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-line-management',
  templateUrl: './line-management.component.html',
  styleUrls: ['./line-management.component.css'],
  standalone: false
})
export class LineManagementComponent implements OnInit {

  @Input()
  procedureInParam?: string;

  customer: CustomerInterface;
  selectedLine: LineInterface;
  proceduresList: Array<MsisdnProcedureInterface> = [];
  allProceduresList: Array<MsisdnProcedureInterface> = [];
  inProgressProceduresList: Array<MsisdnProcedureInterface> = [];
  specificProceduresList: Array<MsisdnProcedureInterface> = [];
  optionProceduresList: Array<MsisdnProcedureInterface> = [];
  activeOptionProceduresList: Array<MsisdnProcedureInterface> = [];
  consumption: ConsumptionInterface = null;
  selectedProcedure: string = null;
  procedureStatus: string = null;
  lastMessage?: Array<any>;
  constHelper = ConstsHelper;
  portabilityDates: Array<string>;
  environment = environment;

  constructor(
      private store: Store<any>,
      private customerStorageService: CustomerStorageService,
      public displayProcedureMessageService: DisplayProcedureMessageService,
      public portabilityDatesService: PortabilityDatesService,
      private location: Location,
  ) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_CONSUMPTION)).subscribe((response: ConsumptionInterfaceState) => {
      if (false === (response.consumption instanceof Array) && null !== response.consumption) {
        this.consumption = response.consumption;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_LINE)).subscribe((response: LineInterfaceState) => {
      if (response.line != null && window.location.href.includes('gestion') && (this.selectedLine === undefined || this.selectedLine.phoneNumber !== response.line.phoneNumber)) {
        this.selectedLine = response.line;
        this.portabilityDates = [];
        this.portabilityDatesService.get().subscribe(dates => {
          if ([null, ''].indexOf(this.selectedLine.statusDetails.endBilling) === -1) {
            const endBilling = moment(this.selectedLine.statusDetails.endBilling, 'DD/MM/YYYY');
            const tmpList = [];
            for (const date of dates) {
              const momentDate = moment(date, 'DD/MM/YYYY');
              if (parseInt(endBilling.format('YYYYMMDD'), 10) > parseInt(momentDate.format('YYYYMMDD'), 10)) {
                tmpList.push(date.toString());
              }
            }
            this.portabilityDates = tmpList;
          } else {
            this.portabilityDates = dates;
          }
          this.store.dispatch(new GetMsisdnProcedures(this.selectedLine));
        });
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_MSISDN_PROCEDURES)).subscribe((response: MsisdnProcedureInterfaceState) => {
      this.proceduresList = [];
      this.inProgressProceduresList = [];
      this.specificProceduresList = [];
      this.activeOptionProceduresList = [];
      this.optionProceduresList = [];
      this.allProceduresList = [];
      if (null !== response.msisdnProcedures && this.selectedLine !== undefined && this.selectedLine !== null) {
        this.allProceduresList = response.msisdnProcedures;
        for (const procedure of response.msisdnProcedures) {
          if (this.checkProcedureVisibility(procedure)) {
            const localStorageBlockUnblockLineProcedure = ConstsHelper.LOCAL_STORAGE_TEMPORARILY_BLOCK_UNBLOCK_LINE_PROCEDURE + '_' + this.selectedLine.phoneNumber;
            const localStorageRefillOrPassProcedure = ConstsHelper.LOCAL_STORAGE_TEMPORARILY_BLOCK_REFILL_OR_PASS_PROCEDURE + '_' + this.selectedLine.phoneNumber;
            if (localStorage.getItem(localStorageBlockUnblockLineProcedure) && procedure.code === ConstsHelper.PROCEDURE_UNBLOCK_LINE) {
              const data = JSON.parse(localStorage.getItem(localStorageBlockUnblockLineProcedure));
              if (parseInt(moment(new Date()).subtract(30, 'minute').format('YYYYMMDDHHmm'), 10) < parseInt(data.date, 10)) {
                procedure.status = 'in_progress';
              } else {
                localStorage.removeItem(localStorageBlockUnblockLineProcedure);
              }
            }
            if (localStorage.getItem(localStorageRefillOrPassProcedure) && procedure.code === ConstsHelper.PROCEDURE_REFILL_OR_PASS) {
              const data = JSON.parse(localStorage.getItem(localStorageRefillOrPassProcedure));
              if (parseInt(moment(new Date()).subtract(30, 'minute').format('YYYYMMDDHHmm'), 10) < parseInt(data.date, 10)) {
                procedure.status = 'in_progress';
              } else {
                localStorage.removeItem(localStorageRefillOrPassProcedure);
              }
            }
            if (procedure.timeout !== null || procedure.status === 'wait_form') {
              this.specificProceduresList.push(procedure);
            }
            if (procedure.status === 'finished' || procedure.status === 'disabled' || procedure.status === 'wait_form') {
              if (procedure.section === 'option' && this.optionToCheck(procedure.code) === true) {
                this.activeOptionProceduresList.push(procedure);
              } else if (procedure.section === 'option' && this.optionToCheck(procedure.code) === false) {
                this.optionProceduresList.push(procedure);
              } else if (procedure.section !== 'option') {
                this.proceduresList.push(procedure);
                if (
                    (this.procedureInParam === 'debloquer-ligne' && procedure.code === ConstsHelper.PROCEDURE_UNBLOCK_LINE) ||
                    (this.procedureInParam === 'terminate-line' && procedure.code === ConstsHelper.PROCEDURE_TERMINATE_LINE) ||
                    (this.procedureInParam === 'recharge' && procedure.code === ConstsHelper.PROCEDURE_REFILL_OR_PASS) ||
                    (this.procedureInParam === 'retractation' && procedure.code === ConstsHelper.PROCEDURE_RETRACTION)
                ) {
                  this.getProcedure(procedure);
                  localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_PROCEDURE_TO_OPEN);
                  this.procedureInParam = null;
                }
              }
            } else {
              this.inProgressProceduresList.push(procedure);
            }
          }
        }
      }
    });

    this.customer = this.customerStorageService.getCustomer();
    this.store.pipe(select(ConstsHelper.REDUCER_SELECTED_PROCEDURE)).subscribe((response: SelectedProcedureInterfaceState) => {
      if (response.code != null) {
        this.selectedProcedure = response.code;
      }
    });
  
    // delete callback url
    if (localStorage.getItem(ConstsHelper.LOCAL_STORAGE_CONNEXION_CALLBACK_URL)) {
      setTimeout(() => {
        localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_CONNEXION_CALLBACK_URL);
      }, 5000);
    }
  }

  getInProgressProcedure(procedure: MsisdnProcedureInterface) {
    this.displayProcedureMessageService.displayInProgressMessage(procedure);
  }

  getProcedure(procedure: MsisdnProcedureInterface) {
    this.procedureStatus = procedure.status;
    this.lastMessage = procedure.lastMessage;
    if (procedure.status === 'wait_form') {
      if (procedure.code === this.constHelper.PROCEDURE_SIM_TRACKING) {
        window.open(procedure.lastMessage['data']['url'], '_blank');
      } else {
        if (procedure.code === ConstsHelper.PROCEDURE_UNBLOCK_LINE && !this.location.path().includes('debloquer-ligne')) {
          this.location.replaceState(this.location.path() + '/debloquer-ligne');
        }
        this.store.dispatch(new UpdateSelectedProcedure(procedure.code));
      }
      if (procedure.code === this.constHelper.PROCEDURE_MAT_TRACKING) {
        window.open(procedure.lastMessage['data']['url'], '_blank');
      }
    } else if (procedure.status !== 'disabled') {
      if (this.constHelper.PROCEDURE_INSURANCE === procedure.code) {
        window.open(environment.data.insuranceUrl, '_blank');
      } else {
        if (
            procedure.code === this.constHelper.PROCEDURE_CHANGE_OFFER ||
            procedure.code === this.constHelper.PROCEDURE_NOT_RECEIVED_CARD ||
            procedure.code === this.constHelper.PROCEDURE_ORDER_SIM_CARD
        ) {
          this.store.dispatch(new GetAddress());
        }
        this.store.dispatch(new UpdateSelectedProcedure(procedure.code));
      }
    } else {
      this.displayProcedureMessageService.displayConflictProcedureMessage(this.inProgressProceduresList, procedure, this.selectedLine.phoneNumber, this.specificProceduresList);
    }
  }

  /**
   *
   * @param procedureCode
   * @param isOption
   * @param force
   */
  getPrice(procedureCode: string, isOption: boolean, force: boolean) {
    if (
        [
          ConstsHelper.PROCEDURE_CHANGE_OFFER,
          ConstsHelper.PROCEDURE_LOSS_STEAL,
          ConstsHelper.PROCEDURE_NOT_RECEIVED_CARD
        ].indexOf(procedureCode) === -1 || force === true) {
      const priceType = (this.customer.siret === '' || this.customer.siret === null) ? 'TTC' : 'HT';
      return this.getOptionPrice(procedureCode, priceType, isOption);
    } else {
      return null
    }
  }

  private getOptionPrice(procedureCode: string, priceType: string, isOption: boolean) {
    let price = null;
    let perMonth = null;

    for (const procedure of this.allProceduresList) {
      if (procedure.code === procedureCode && procedure.ttc) {
        price =  (priceType === 'HT') ? (procedure.ht + '€ HT') : (procedure.ttc + '€');
        perMonth = procedure.perMonth;
      }
    }
    if (isOption && null === price) {
      if (procedureCode === ConstsHelper.PROCEDURE_ACTIVATION_5G) {
        for (const option of this.selectedLine.offer.options) {
          if (option.label.includes('5G') && option.priceTtc > 0) {
            price = priceType === 'HT' ? option.priceHt + '€ HT' : option.priceTtc + '€';
          }
        }
      }
      if (price === null) {
        price = 'Gratuite';
      }
    }
    if (price !== null) {
      return {
        price: price.replace('.', ','),
        perMonth
      } as PriceDetailsInterface;
    }
    return null;
  }

  private checkProcedureVisibility(procedure: MsisdnProcedureInterface) {
    if (this.constHelper.PROCEDURE_RECHARGE_DATA === procedure.code && this.consumption.total.data.percent < 90 && environment.data.brand === 'prixtel') {
      return false;
    } else if (this.constHelper.PROCEDURE_RECHARGE_VOICE === procedure.code && this.consumption.total.voice.percent < 90) {
        return false;
    } else if (this.constHelper.PROCEDURE_CHANGE_OFFER === procedure.code && (this.portabilityDates === undefined || this.portabilityDates.length === 0)) {
      return false;
    } else if (this.constHelper.PROCEDURE_CHANGE_NETWORK === procedure.code && (this.portabilityDates === undefined || this.portabilityDates.length === 0)) {
      return false;
    } else {
      return true;
    }
  }

  private optionToCheck(procedure: string) {
    switch (procedure) {
      case this.constHelper.PROCEDURE_SURTAX_NUMBER:
        if (this.selectedLine.optionsStatus.surtax_number === 'blocking_in_progress' || this.selectedLine.optionsStatus.surtax_number === true) {
          return true;
        } else if (this.selectedLine.optionsStatus.surtax_number === 'unblocking_in_progress' || this.selectedLine.optionsStatus.surtax_number === false) {
          return false;
        } else {
          return null;
        }
      case this.constHelper.PROCEDURE_TOGGLE_SMS_INTERNET_PLUS:
        if (this.selectedLine.optionsStatus.blocking_multimedia_purchase === 'blocking_in_progress' || this.selectedLine.optionsStatus.blocking_multimedia_purchase === true) {
          return true;
        } else if (this.selectedLine.optionsStatus.blocking_multimedia_purchase === 'unblocking_in_progress' || this.selectedLine.optionsStatus.blocking_multimedia_purchase === false) {
          return false;
        } else {
          return null;
        }
      case this.constHelper.PROCEDURE_BLOCKING_MULTIMEDIA_PURCHASE:
        if (this.selectedLine.optionsStatus.blocking_multimedia_purchase === 'blocking_in_progress' || this.selectedLine.optionsStatus.blocking_multimedia_purchase === true) {
          return true;
        } else if (this.selectedLine.optionsStatus.blocking_multimedia_purchase === 'unblocking_in_progress' || this.selectedLine.optionsStatus.blocking_multimedia_purchase === false) {
          return false;
        } else {
          return null;
        }
      case this.constHelper.PROCEDURE_THREE_WAY_CONFERENCE:
        return this.selectedLine.optionsStatus.three_way_conference;
      case this.constHelper.PROCEDURE_VISUAL_MESSAGING:
        return this.selectedLine.optionsStatus.visual_messaging;
      case this.constHelper.PROCEDURE_CONTACTS:
        return this.selectedLine.optionsStatus.contacts;
      case this.constHelper.PROCEDURE_ACTIVATION_5G:
        return this.selectedLine.optionsStatus.toggle_5g;
      default:
        return false;
    }
  }
}
